// Import Packages
import { useRecoilState, useSetRecoilState, useRecoilValue } from 'recoil';
import React, { useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// Import Services
import appService from "../../../../services/ApplicationService/ApplicationService";
import SettingsService from '../../../../services/SettingsService/SettingsService';

// Import Material UI
import TextField from "@material-ui/core/TextField";
import { Button, Checkbox } from '@material-ui/core';
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormControl from "@material-ui/core/FormControl";

// Import Pages
import { alertState, oauthState } from "../../../../recoil-store/recoil-state";
import { useRecoilActions } from '../../../../recoil-store/recoil-actions';
import RedirectConfirm from '../../../../components/DataTable/DeleteConfirm';
import DeleteConfirm from '../../../../components/DataTable/DeleteConfirm';

// Import OAuth File
//import { oauthGenerator } from "../../../../helpers/oauth/oauth"

// Import External Package
import jwt_decode from "jwt-decode";

// Import Services
import AuthService from "../../../../services/AuthService/AuthService";
import SettingService from "../../../../services/SettingsService/SettingsService";
import CredentialService from "../../../../services/CredentialService/CredentialService";

// Import Css
import "./AppCredentialProcess.css"
import BoolSelect from "../../../../components/FlowConfigurationInputs/BoolSelect/BoolSelect";

const envType = process.env.REACT_APP_ENV_TYPE;

const AppCredential = ({
    selectedApp,
    setSelectedApp,
    appCredentialId,
    setApplication,
    cancel,
    showCancelButton,
    setRefreshCredentials,
    setShowCreateConnector,
    inputColor,
    data
}) => {
    const [name, setName] = useState('');
    const [form, setForm] = useState({});
    const [authorizationConf, setAuthorizationConf] = useState({});
    const [createStatus, setCreateStatus] = useState(false);
    const [updateStatus, setUpdateStatus] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openChangeDefault, setOpenChangeDefault] = useState(false);
    const [changeApp, setChangeApp] = useState({});
    const [oauthEnabled, setOauthEnabled] = useState(false);

    const [oauthPopupWindow, setOauthPopupWindow] = useState(null);
    const oauthPopupState = useRecoilValue(oauthState);
    const [oauthStatus, setOauthStatus] = useState(false);
    const [oauthDisconnect, setOauthDisconnect] = useState("manual");
    const [openRedirectConfirm, setOpenRedirectConfirm] = useState(false);
    const [isDefault, setIsDefault] = useState(false);
    const [tempCredentialId, setTempCredentialId] = useState("");
    const [passwordKeys, setPasswordKeys] = useState([]);

    const recoilActions = useRecoilActions();
    const history = useNavigate();

    const setAlert = useSetRecoilState(alertState);
    const label = "CONTENT.CONFIGURATION-FORM.TRIGGER-STATIC.CONNECTORS.CREATE."

    useEffect(() => {
        if (oauthPopupState) {
            if (oauthPopupWindow) {
                setRefreshCredentials(new Date());
                oauthPopupWindow.close();
            }
            //setOauthPopupState(false);
        }
    }, [oauthPopupState])

    useEffect(() => {
        let f = {};
        setPasswordKeys([]);
        if (appCredentialId) {
            const fetchData = async () => {
                const response = await appService.getAppCredential(appCredentialId);
                if (response && response.code === 200) {
                    setName(response.data.name);
                    let passwords = [];
                    selectedApp.connector_fields.forEach(field => {
                        if (field.type === 'password') {
                            //setPasswordKey(field.identifier);
                            passwords.push(field)
                        }
                        if (field.identifier === "authorization") {
                            setAuthorizationConf(field);
                        }
                        if (field.identifier === "authentication_type" && response.data.credentials[field.identifier].value === "oauth20") {
                            setOauthEnabled(true);
                            if (response.data.credentials.is_active) {
                                setOauthStatus(true);
                            }

                            if (response.data.credentials.authorization.value.disconnect) {
                                setOauthDisconnect(response.data.credentials.authorization.value.disconnect);
                            }
                        }
                        if (response.data.credentials[field.identifier]) {
                            f[field.identifier] = response.data.credentials[field.identifier];
                        }
                    })
                    setPasswordKeys(passwords);
                    const isDefaultValue = !!response.data.is_default
                    setIsDefault(isDefaultValue);
                    setForm(f);
                    setLoading(true);
                }
            }
            fetchData().then(r => r);
        } else {
            // eslint-disable-next-line array-callback-return
            selectedApp.connector_fields.map(field => {
                if (["path", 'accessible_resources', 'api_url_format'].find(x => x === field.identifier)) {
                    f[field.identifier] = { type: field.type, value: field.default_value };
                }
                if (field.identifier === "authorization") {
                    setAuthorizationConf(field);
                    f[field.identifier] = { type: field.type, value: {} }
                }
                else if (field.identifier === "authentication_type") {
                    if (field.default_value === 'oauth20') {
                        setOauthEnabled(true);
                    }
                }

                if (field.visible) {
                    f[field.identifier] = { type: field.type, value: field.default_value }
                }
            })

            const isDefaultValue = false

            setIsDefault(isDefaultValue);
            setForm(f);
            setLoading(true);
        }
    }, [])

    const { t } = useTranslation();

    const setStringField = (key, value, type) => {
        let copyForm = { ...form };
        copyForm[key] = { value, type };
        setForm(copyForm);
    }

    const handleCredentialProcess = async (process) => {
        if (checkInvalidForm()) {
            const data = {
                name: name,
                application_id: selectedApp.id,
                credentials: { ...form },
                is_default: isDefault
            }

            let response = {};
            let appCid = appCredentialId;
            if (!appCredentialId && tempCredentialId) {
                appCid = tempCredentialId;
            }
            switch (process) {
                default:
                    break;
                case "test":
                    response = await appService.testAppCredential(data);
                    if (response && response.status) {
                        appCid ? setUpdateStatus(true) : setCreateStatus(true);
                    }
                    break;
                case "update":
                    response = await appService.updateAppCredential(appCid, data);
                    break;
                case "create":
                    response = await appService.createAppCredential(data);
                    break;
                case "oauth":
                    // recoilActions.connection();
                    // const refreshToken = localStorage.getItem("refreshToken")
                    // // const decoded = jwt_decode(refreshToken);
                    // const payload = {
                    //     credential_name: name,
                    //     application: selectedApp.name,
                    //     credential_id: appCredentialId,
                    //     // session_id: decoded.session_id,
                    //     // client_id: decoded.id,
                    //     //x_token: JSON.parse(localStorage.getItem("authToken")),
                    //     credentials: { ...form }
                    // }
                    // //uri = await oauthGenerator(payload);
                    // const resp = await AuthService.oAuthGenerate(payload);
                    // openOauth(resp.data ? resp.data : "");
                    // break;
                    const result = await SettingService.getSettings();
                    if (!result) {
                        setAlert(alert => ({
                            ...alert,
                            show: true,
                            message: t("MESSAGES.GENERAL.NETWORK-ERROR"),
                            severity: 'error'
                        }));
                        break;
                    }

                    if (result.code === 500) {
                        setAlert(alert => ({
                            ...alert,
                            show: true,
                            message: result.message,
                            severity: 'error'
                        }));
                        break;
                    }
                    //((result.data.enable_ssl && result.data.service_https_port !== 0) ||
                    // (!result.data.enable_ssl && result.data.service_http_port !== 0)))
                    if (result.code === 200) {
                        if (result.data.service_host_name && result.data.service_https_port) {
                            // const port = result.data.enable_ssl && result.data.service_https_port !== 0 ? result.data.service_https_port : result.data.service_http_port
                            // const target_url = `${result.data.service_host_name}`;
                            let target_url;
                            if (envType === "OnCloud") {
                                target_url = `${result.data.service_host_name}`;
                            } else {
                                target_url = `${result.data.service_host_name}:${result.data.service_https_port}`;
                            }

                            const res = await SettingsService.healthCheck(target_url);
                            if (!res?.status) {
                                setAlert(alert => ({
                                    ...alert,
                                    show: true,
                                    message: t("MESSAGES.CREDENTIAL.HOST-NAME-COULD-NOT-BE-ACCESSED"),
                                    severity: 'error'
                                }));
                                setOpenRedirectConfirm(true)
                                break
                            }
                            recoilActions.connection();
                            const payload = {
                                credential_name: name,
                                application_id: selectedApp.id,
                                credential_id: appCid,
                                // session_id: decoded.session_id,
                                // client_id: decoded.id,
                                //x_token: JSON.parse(localStorage.getItem("authToken")),
                                credentials: { ...form },
                                target_url,
                                is_default: isDefault
                            }
                            const resp = await AuthService.oAuthGenerate(payload);
                            if (resp) {
                                if (resp.status) {
                                    if (!appCredentialId) {
                                        setTempCredentialId(resp.cid);
                                    }
                                    openOauth(resp.data);
                                } else {
                                    setAlert(alert => ({
                                        ...alert,
                                        show: true,
                                        message: t("MESSAGES.CREDENTIAL." + resp.message),
                                        severity: 'error'
                                    }));
                                }
                            } else {
                                setAlert(alert => ({
                                    ...alert,
                                    show: true,
                                    message: t("MESSAGES.GENERAL.NETWORK-ERROR"),
                                    severity: 'error'
                                }));
                            }
                            break;
                        }
                    }

                    setAlert(alert => ({
                        ...alert,
                        show: true,
                        message: t("MESSAGES.CREDENTIAL.REDIRECT-HOST-NAME-NOT-FOUND"),
                        severity: 'error'
                    }));
                    setOpenRedirectConfirm(true);
                    break;
                case "oauth-revoke":
                    break;
                case "oauth-revoke-manual":

                    break;
            }

            if (response && response.message) {
                let message = t("MESSAGES.TRIGGER-STATIC.CONNECTOR." + response.message);
                if (response.message.includes("System Message:")) {
                    message = response.message.split("System Message: ")[1];
                }
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message,
                    severity: response.status ? 'success' : 'error'
                }));
                if (process !== "test" && response.status) {
                    setRefreshCredentials(new Date());
                    if (setShowCreateConnector) {
                        setShowCreateConnector(false);
                    }
                    setForm({});
                }
            }
        }
    }

    const checkInvalidForm = () => {
        if (name.length < 3) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t("MESSAGES.APP-CREDENTIAL.NAME-MUST-BE-AT-LEAST"),
                severity: 'info'
            }));
            return false;
        }
        let display_name = '';
        let isInvalid = true;
        for (const field of selectedApp.connector_fields) {
            if (!field.visible) {
                if (!field.unvisibleForce && field.depends !== '') {
                    const arrName = field.depends.split('.');
                    if (!form[arrName[0]] || !form[arrName[0]].value) {
                        isInvalid = false;
                        display_name = field.display_name
                        break;
                    } else if (form[arrName[0]].value === arrName[1]) {
                        if (field.required !== false && !checkValue(form[field.identifier])) {
                            isInvalid = false;
                            display_name = field.display_name
                            break;
                        }
                    }
                }
            } else {
                if (field.required !== false && !checkValue(form[field.identifier])) {
                    isInvalid = false;
                    display_name = field.display_name
                    break
                }
            }
        }
        if (!isInvalid) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: `${t(label + display_name)} : ${t("MESSAGES.FIELD-REQUIRED")}`,
                severity: 'info'
            }));
        }
        return isInvalid;
    }

    const checkValue = (data) => {
        if (!data || !data.value) {
            return false;
        }
        let isValid = true;
        switch (data.type) {
            case "string":
            case "password":
            case "email":
                isValid = data.value !== ""
                break;

            default:
                break;
        }

        return isValid;
    }

    const checkDependings = (dependArray) => {
        let condition = true;
        for (let item of dependArray) {
            if (item !== '') {
                const arrName = item.split('.');
                const currentCondition = form[arrName[0]] && form[arrName[0]].value === arrName[1];
                if (!currentCondition) {
                    condition = false;
                    break;
                }
            }
        }

        return condition;
    }

    const checkVisible = (field) => {
        if (field.unvisibleForce) return false;
        if (!field.visible) {
            if (Array.isArray(field.depends)) {
                return checkDependings(field.depends);
            } else {
                if (field.depends !== '') {
                    const arrName = field.depends.split('.');

                    return form[arrName[0]] && form[arrName[0]].value === arrName[1]
                }
            }
        }

        return field.visible;
    }

    const handleAuthorizationConfiguration = (f, value) => {
        if (value === "oauth20") {
            setOauthEnabled(true);
        } else {
            setOauthEnabled(false);
        }
        if (authorizationConf.auth_conf) {
            authorizationConf.auth_conf.length && authorizationConf.auth_conf.forEach(conf => {
                const type = conf.depends.split('.')[1];

                if (type === value) {
                    f[authorizationConf.identifier].value = {
                        value_depends: conf.value_depends,
                        disconnect: conf.disconnect,
                        success_response_check: conf.success_response_check,
                        authorization_key: conf.authorization_key,
                        authorization_layer: conf.authorization_layer,
                        authorization_prefix: conf.authorization_prefix,
                        method: conf.method,
                        generate_value: conf.generate_value,
                        additional_layer: conf.additional_layer
                    }
                }
            });

            return f;
        } else {
            return {};
        }
    }

    const changeField = (key, value) => {
        if (key === "is_default") {
            if (value) {
                let sameDefaultFound
                data.forEach((app) => {
                    if ((app.application_name === selectedApp.name && app.is_default && app.id !== appCredentialId) || (app.application?.name === selectedApp.name && app.is_default && app.id !== appCredentialId)) {
                        setOpenChangeDefault(true)
                        sameDefaultFound = true
                        return
                    }
                })
                if (sameDefaultFound) return
            }
            handleChangeIsDefault(value)
            return;
        }
        let f = { ...form };
        f[key].value = value;
        if (key === "authentication_type") {
            f = handleAuthorizationConfiguration(f, value);
        }

        setForm(f);

        defaultValueAndDependingCheck();
    }

    const handleChangeIsDefault = async (is_default) => {
        setIsDefault(is_default)
        if (oauthEnabled && oauthStatus && appCredentialId) {
            const response = await appService.changeIsDefault(appCredentialId, { application_id: selectedApp.id, is_default });
            if (response && response.message) {
                setAlert(alert => ({
                    ...alert,
                    show: true,
                    message: t("MESSAGES.TRIGGER-STATIC.CONNECTOR." + response.message),
                    severity: response.status ? 'success' : 'error'
                }));
            }
        }
    }

    const defaultValueAndDependingCheck = () => {
        let f = { ...form };
        selectedApp.connector_fields.map(field => {
            if (Array.isArray(field.depends)) {
                if (checkDependings(field.depends)) {
                    setFieldValueAsDefault(f, field)
                }
            } else {
                if (field.depends !== '') {
                    const arrName = field.depends.split('.');
                    if (form[arrName[0]] && form[arrName[0]].value === arrName[1]) {
                        setFieldValueAsDefault(f, field)
                    }
                }
            }
        })

        setForm(f);
    }

    const setFieldValueAsDefault = (f, field) => {
        if (!f.hasOwnProperty(field.identifier)) {
            f[field.identifier] = {}
        }
        if (field.default_value && field.default_value !== "") {

            f[field.identifier].value = field.default_value;
            f[field.identifier].type = field.type;
        }
    }

    const openOauth = (url) => {
        const width = 700;
        const height = 600;
        const left = window.screenX + (window.outerWidth - width) / 2;
        const top = window.screenY + (window.outerHeight - height) / 2.5;
        const title = `${name} OAuth`;
        const popup = window.open(url, title, `width=${width},height=${height},left=${left},top=${top}`);
        // const popup = window.open(url, “popup”, “popup = true”);
        // const checkPopup = setInterval(() => {
        //     console.log('popup: ', popup.location.href)
        //     console.log('window: ',popup.location)
        //     if (popup.location.href
        //         .includes("https://assistant.autommate.app/oauth/api/v1/oauth/subscribe")) {
        //         popup.close()
        //     }
        //     if (!popup || !popup.closed) return;
        //     clearInterval(checkPopup);
        // }, 1000);
        setOauthPopupWindow(popup);
    }

    const redirectSettingPage = () => {
        history(`/settings/port`);
    }

    const checkAndDelete = async () => {
        if (tempCredentialId) {
            await CredentialService.deleteAppCredential(tempCredentialId);
            setTempCredentialId("");
        }
    }


    const checkTestButtonDisabled = () => {
        if (appCredentialId && passwordKeys.length) {
            for (const p of passwordKeys) {
                if (checkVisible(p) && form[p.identifier] && form[p.identifier].value === '******') {
                    return true;
                }
            }
        }
        return false;
    }

    return (
        <div style={{ textAlign: "left", width: '100%' }}>
            {
                loading && selectedApp && selectedApp.connector_fields && selectedApp.connector_fields.length && (
                    <>
                        <div className="head-title-credential">
                            {appCredentialId ? <span>Edit Credential</span> : <span>Add New Credential</span>}

                        </div>
                        <div className="modal-form-container">
                            <div className="form-element credential-element">
                                <div className="modal-text add-autom">
                                    <div>{t(label + "CONNECTOR-NAME")}</div>
                                </div>
                                <TextField
                                    id="filled-size-small"
                                    autoFocus
                                    value={name}
                                    onChange={(e) => setName(e.target.value)}
                                    variant="outlined"
                                    size="small"
                                    inputProps={{
                                        style: {
                                            fontSize: 15,
                                            height: 20,
                                            paddingLeft: 15,
                                            backgroundColor: inputColor ? inputColor : '#fff'
                                        }
                                    }}
                                />

                                <small className="help-text">{t(label + 'CONNECTOR-NAME-HELP')}</small>

                            </div>
                            {/* eslint-disable-next-line array-callback-return */}
                            {selectedApp?.connector_fields?.map((field, i) => {
                                const key = field.identifier;
                                if (checkVisible(field)) {
                                    switch (field.type) {
                                        case 'string':
                                        case 'password':
                                        case 'email':
                                            return (
                                                <div key={i} className="form-element credential-element">
                                                    <div className="modal-text add-autom">
                                                        <div>{t(label + field.display_name)}</div>
                                                    </div>
                                                    <TextField
                                                        id="filled-size-small"
                                                        type={field.type}
                                                        value={form[key]?.value}
                                                        onChange={(e) => setStringField(key, e.target.value, field.type)}
                                                        variant="outlined"
                                                        size="small"
                                                        inputProps={{
                                                            style: {
                                                                fontSize: 15,
                                                                height: 20,
                                                                paddingLeft: 15,
                                                                backgroundColor: inputColor ? inputColor : '#fff'
                                                            }
                                                        }}
                                                    />
                                                    {field.help_available && (
                                                        <small
                                                            className="help-text">{t(label + field.display_name + '-HELP')}</small>
                                                    )}
                                                </div>
                                            )
                                        case 'single_select':
                                            return <div key={i} className="form-element credential-element">
                                                <div className="modal-text"
                                                    style={{ marginBottom: 5 }}>{t(label + field.display_name)}</div>
                                                <FormControl
                                                    variant="outlined"
                                                    style={{ width: "100%" }}
                                                >
                                                    <Select
                                                        labelId="demo-simple-select-outlined-label"
                                                        style={{
                                                            backgroundColor: inputColor ? inputColor : "#fff",
                                                            height: "41px",
                                                            fontSize: "15px",
                                                            paddingLeft: 15
                                                        }}
                                                        id="demo-simple-select-outlined"
                                                        value={form[key]?.value}
                                                        onChange={(e) => changeField(key, e.target.value)}
                                                    >
                                                        {field.options.length > 0 &&
                                                            field.options?.map((item, index) => (
                                                                <MenuItem
                                                                    style={{ fontSize: 12 }}
                                                                    key={index}
                                                                    value={item.value}
                                                                >
                                                                    {item.name}
                                                                </MenuItem>
                                                            ))}
                                                    </Select>
                                                    {field.help_available && (
                                                        <small
                                                            className="help-text">{t(label + field.display_name + '-HELP')}</small>
                                                    )}
                                                </FormControl>
                                            </div>
                                        default:
                                            return (<div />)
                                    }
                                }
                            })}
                            <div className="form-element credential-element">
                                <span className='default-input-container'>Set as default credential <Checkbox className='credential-default-checkbox' onClick={() => changeField("is_default", !isDefault)} checked={isDefault} /></span>
                            </div>
                        </div>
                    </>
                )
            }
            {oauthEnabled ? (
                <div className="button-group">
                    {oauthStatus ? (
                        <Button type="button" className={`action-button oauth-button disconnect test ${!showCancelButton ? "w-48p" : ""}`}
                            onClick={() => handleCredentialProcess(oauthDisconnect === "manual" ? "oauth-revoke-manual" : "oauth-revoke")}>
                            {/* {dialog.type === 'update' ? t('CONTENT.ROLE.UPDATE-ROLE') : t('CONTENT.ROLE.ADD-ROLE')} */}
                            <img className="oauth-img" src={selectedApp.image_path} alt={selectedApp.name} />
                            {t(label + 'OAUTH-DISCONNECT')}
                        </Button>

                    ) : (
                        <Button type="button" className={`action-button oauth-button create${!showCancelButton ? "w-48p" : ""}`}
                            onClick={() => handleCredentialProcess("oauth")}>
                            {/* {dialog.type === 'update' ? t('CONTENT.ROLE.UPDATE-ROLE') : t('CONTENT.ROLE.ADD-ROLE')} */}
                            {t(label + 'OAUTH-CONNECT')}
                        </Button>
                    )}

                </div>
            ) : (
                <div className="button-group">
                    {
                        form &&
                        form.authorization &&
                        Object.keys(form?.authorization?.value).length > 0 &&
                        form.authorization.value.method &&
                        (<Button type="button" disabled={checkTestButtonDisabled()} className={`action-button test ${!showCancelButton ? "w-48p" : ""}`}
                            onClick={() => handleCredentialProcess("test")}>
                            {/* {dialog.type === 'update' ? t('CONTENT.ROLE.UPDATE-ROLE') : t('CONTENT.ROLE.ADD-ROLE')} */}
                            {t(label + 'CONNECT')}
                        </Button>
                        )}
                    <Button type="button"
                        className={`action-button create ${!showCancelButton ? "w-48p" : ""} ${!updateStatus && !createStatus &&
                            (form && form.authorization && Object.keys(form.authorization.value).length > 0 && form.authorization.value.method) ? "disabled" : ""}`}
                        disabled={appCredentialId && checkTestButtonDisabled()}
                        onClick={appCredentialId ? () => (!form.authorization.value.method ? handleCredentialProcess("update") : updateStatus && handleCredentialProcess("update")) : () =>
                            (form && form.authorization && Object.keys(form.authorization.value).length > 0 && !form.authorization.value.method) ?
                                handleCredentialProcess("create") : createStatus && handleCredentialProcess("create")}
                    >
                        {/* {dialog.type === 'update' ? t('CONTENT.ROLE.UPDATE-ROLE') : t('CONTENT.ROLE.ADD-ROLE')} */}
                        {appCredentialId ? t(label + 'CONNECT-AND-UPDATE') : t(label + 'CONNECT-AND-CREATE')}
                    </Button>
                </div>
            )}
            {openRedirectConfirm && <RedirectConfirm setOpenDelete={setOpenRedirectConfirm} message={t('MESSAGES.CREDENTIAL.REDIRECT-TO-SETTING-PAGE-QUESTION')} deleteFunc={redirectSettingPage} />}
            {openChangeDefault && <DeleteConfirm setOpenDelete={setOpenChangeDefault} message={t("MESSAGES.CREDENTIAL.DEFAULT-IS-EXIST")}
                deleteFunc={() => handleChangeIsDefault(true)}
                okButtonLabel={t("MESSAGES.CREDENTIAL.MAKE-THIS-DEFAULT")} cancelButtonLabel={t("MESSAGES.CREDENTIAL.CANCEL")} />}
        </div>
    )

}

export default AppCredential;
